import React from 'react';
import PropTypes from 'prop-types';

const BulkPayments = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.54 1.64999H2.45999C2.02896 1.65197 1.61614 1.82407 1.31135 2.12886C1.00656 2.43365 0.834462 2.84646 0.832489 3.27749V14.7225C0.834462 15.1535 1.00656 15.5663 1.31135 15.8711C1.61614 16.1759 2.02896 16.348 2.45999 16.35H15.54C15.971 16.348 16.3838 16.1759 16.6886 15.8711C16.9934 15.5663 17.1655 15.1535 17.1675 14.7225V3.27749C17.1655 2.84646 16.9934 2.43365 16.6886 2.12886C16.3838 1.82407 15.971 1.65197 15.54 1.64999V1.64999ZM15.54 14.7225H2.45999V3.27749H15.54V14.7225Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5475 4.91249H4.095C3.6435 4.91249 3.2775 5.2785 3.2775 5.72999C3.2775 6.18148 3.6435 6.54749 4.095 6.54749H6.5475C6.99899 6.54749 7.365 6.18148 7.365 5.72999C7.365 5.2785 6.99899 4.91249 6.5475 4.91249Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5475 8.1825H4.095C3.6435 8.1825 3.2775 8.5485 3.2775 9C3.2775 9.45149 3.6435 9.8175 4.095 9.8175H6.5475C6.99899 9.8175 7.365 9.45149 7.365 9C7.365 8.5485 6.99899 8.1825 6.5475 8.1825Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5475 11.4525H4.095C3.6435 11.4525 3.2775 11.8185 3.2775 12.27C3.2775 12.7215 3.6435 13.0875 4.095 13.0875H6.5475C6.99899 13.0875 7.365 12.7215 7.365 12.27C7.365 11.8185 6.99899 11.4525 6.5475 11.4525Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6689 10.3709L11.4914 11.5184L10.3514 10.3709C10.2812 10.2935 10.1955 10.2317 10.0999 10.1894C10.0043 10.1472 9.90096 10.1253 9.79645 10.1253C9.69194 10.1253 9.58858 10.1472 9.493 10.1894C9.39743 10.2317 9.31174 10.2935 9.24145 10.3709C9.16532 10.4411 9.10456 10.5263 9.06301 10.6212C9.02145 10.7161 9 10.8185 9 10.9221C9 11.0257 9.02145 11.1281 9.06301 11.223C9.10456 11.3179 9.16532 11.4031 9.24145 11.4734L11.2589 13.4609C11.2938 13.496 11.3353 13.5239 11.381 13.5429C11.4267 13.562 11.4757 13.5718 11.5252 13.5718C11.5747 13.5718 11.6237 13.562 11.6694 13.5429C11.7151 13.5239 11.7566 13.496 11.7914 13.4609L13.7789 11.4734C13.8551 11.4031 13.9158 11.3179 13.9574 11.223C13.9989 11.1281 14.0204 11.0257 14.0204 10.9221C14.0204 10.8185 13.9989 10.7161 13.9574 10.6212C13.9158 10.5263 13.8551 10.4411 13.7789 10.3709C13.7087 10.2935 13.623 10.2317 13.5274 10.1894C13.4318 10.1472 13.3285 10.1253 13.2239 10.1253C13.1194 10.1253 13.0161 10.1472 12.9205 10.1894C12.8249 10.2317 12.7392 10.2935 12.6689 10.3709Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7789 6.59849L11.7914 4.61099C11.7566 4.57584 11.7151 4.54794 11.6694 4.52891C11.6237 4.50987 11.5747 4.50006 11.5252 4.50006C11.4757 4.50006 11.4267 4.50987 11.381 4.52891C11.3353 4.54794 11.2938 4.57584 11.2589 4.61099L9.24145 6.59849C9.16532 6.66872 9.10456 6.75396 9.06301 6.84883C9.02145 6.94371 9 7.04616 9 7.14974C9 7.25331 9.02145 7.35577 9.06301 7.45064C9.10456 7.54552 9.16532 7.63076 9.24145 7.70099C9.31174 7.77833 9.39743 7.84012 9.493 7.88241C9.58858 7.92469 9.69194 7.94653 9.79645 7.94653C9.90096 7.94653 10.0043 7.92469 10.0999 7.88241C10.1955 7.84012 10.2812 7.77833 10.3514 7.70099L11.4914 6.55349L12.6389 7.70099C12.7092 7.77712 12.7944 7.83787 12.8893 7.87943C12.9842 7.92098 13.0866 7.94244 13.1902 7.94244C13.2938 7.94244 13.3962 7.92098 13.4911 7.87943C13.586 7.83787 13.6712 7.77712 13.7414 7.70099C13.82 7.63338 13.8837 7.55022 13.9286 7.45676C13.9734 7.36329 13.9983 7.26155 14.0019 7.15796C14.0054 7.05436 13.9874 6.95116 13.949 6.85487C13.9107 6.75857 13.8527 6.67128 13.7789 6.59849Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

BulkPayments.propTypes = {
  fill: PropTypes.string,
};

export default BulkPayments;
